import {
  Button,
  ButtonThemes,
  CloseIcon,
  Col,
  IconButton,
  Input,
  Row,
  SearchIcon,
} from 'plataforma-fundacao-componentes';
import React, { useCallback, useMemo, useReducer, useState } from 'react';
import { filtrosInitialState, filtrosReducer } from './reducer';
import styles from './styles.module.scss';

import { languageValues } from 'helpers/utils/languageUtils';

interface FilterParams {
  texto?: string;
}

const FILTERS_INITIAL_STATE: FilterParams = {
  texto: '',
};

interface Props {
  idEvento: number;
  onChangeFilter: (params: FilterParams) => void;
}

export default function FiltrosConvidados({ onChangeFilter }: Props) {
  const language = languageValues.pages.presents;

  const [{ texto }, dispatch] = useReducer(filtrosReducer, filtrosInitialState);
  const [stateFilters, setStateFilters] = useState<FilterParams>(
    FILTERS_INITIAL_STATE
  );

  const reducerFilters = useMemo<FilterParams>(() => {
    return {
      texto,
    };
  }, [texto]);

  const filtersChanged = useMemo<boolean>(() => {
    return JSON.stringify(reducerFilters) !== JSON.stringify(stateFilters);
  }, [reducerFilters, stateFilters]);

  const handleCPFChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
        .replace(/[-/]/g, '')
        .replace(/\.(?=\d)/g, '');
      setStateFilters({
        ...stateFilters,
        texto: value,
      });
    },
    [setStateFilters, stateFilters]
  );

  const eraseSearchFilter = useCallback(() => {
    setStateFilters({
      ...stateFilters,
      texto: undefined,
    });
  }, [setStateFilters, stateFilters]);

  const toSearch = useCallback(() => {
    dispatch({ type: 'setSearch', value: stateFilters!?.texto! });
    onChangeFilter({
      ...stateFilters,
      texto:
        (stateFilters.texto || '').length >= 3 ? stateFilters.texto : undefined,
    });
  }, [onChangeFilter, stateFilters]);

  return (
    <Row className={styles.root}>
      <Col cols={[12, 12, 6, 6, 6]}>
        <Input
          data-testid={'input-name-or-cpf'}
          value={stateFilters.texto || ''}
          label={language.inputs.nameOrCpfLabel}
          placeholder={language.inputs.nameOrCpfPlaceholder}
          onChange={handleCPFChange}
          rightObject={
            (stateFilters.texto || '').trim().length > 0 ? (
              <IconButton icon={<CloseIcon />} onClick={eraseSearchFilter} />
            ) : undefined
          }
        />
        <Button
          data-testid={'search'}
          theme={ButtonThemes.Primary}
          leftIcon={<SearchIcon />}
          disabled={!filtersChanged}
          onClick={() => {
            if (filtersChanged) {
              toSearch();
            }
          }}
        >
          {language.buttons.search}
        </Button>
      </Col>
    </Row>
  );
}
